import { deepCopy } from '../utils';

const setServiceDocketServiceNoteConfig = {
	queueOnNetworkError: true,
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables, context = {} }) => ({
		type: 'setServiceDocketServiceNote',
		serviceDocketId: variables.id,
		fallbackMachineName: context.offlineMeta?.machineName || null,
	}),
	applyOptimisticUpdate: async ({ client, variables }) => {
		const id = client.cache.identify({ __typename: 'ServiceDocket', id: variables.id });
		if (id) {
			client.cache.modify({ id, fields: { serviceNote: () => variables.note.trim() } });
		}
	},
	getOfflineResult: ({ variables, queueEntry }) => ({
		setServiceDocketServiceNote: {
			__typename: 'ServiceDocket',
			id: variables.id,
			serviceNote: variables.note.trim(),
			offlineQueuedAt: queueEntry.createdAt,
			offline: true,
		},
	}),
};

export default setServiceDocketServiceNoteConfig;
